import { Stack } from "@mui/material";
import { Measurement } from "../../common/apis/dtos";
import { Typography } from "@chr/eds-react";
import './../containerDetails/ContainerDetailsInfo.scss';

interface ContainerDetailsInfoProps {
  title: string;
  information: string | number | Measurement;
  isMobileScreen: boolean;
}

export const ContainerDetailsInfo = ({
  title,
  information,
  isMobileScreen
}: ContainerDetailsInfoProps) => {
  return (
    <div
      data-testid="container-details-info-container"
      className={
        isMobileScreen
          ? 'container-details-info-container-mobile'
          : 'container-details-info-container'
      }
    >
      <Stack
        direction={isMobileScreen ? 'row' : 'column'}
        justifyContent={isMobileScreen ? 'space-between' : 'flex-start'}
        spacing={isMobileScreen ? 2 : 1}
        width={'100%'}
      >
        <Typography variant="body1">{title}</Typography>
        <Typography variant="subtitle2">{information}</Typography>
      </Stack>
    </div>
  );
};